export default class Activity {
  constructor({ reference } = {}) {
    this.reference = reference;
    this.name = this.constructor.name;
  }

  // eslint-disable-next-line class-methods-use-this
  execute() {
  }

  // eslint-disable-next-line class-methods-use-this
  finish() {
  }

  // eslint-disable-next-line class-methods-use-this
  idle() {
    this.reference.decreaseFatigueLevel();
  }
}
